<template>
  <div>
    <!-- 个人中心 -->
    <template v-if="isShow">
      <div class="tac mob-per-top">个人中心</div>
      <div>
        <div @click="goCollect" class="mob-collet">
          <i class="iconfont iconshoucang"></i>
          <span class="f18">收藏夹</span>
          <i class="iconfont fr" style="color:#c7c7cc;font-size:22px;">&#xe641;</i>
        </div>
        <div class="bgc-white padding-20 mt-20">
          <div @click="editPersonInfo">
            <i class="iconfont">&#xe605;</i>
            <span class="f18">个人信息修改</span>
            <i class="iconfont fr" style="color:#c7c7cc;font-size:22px;">&#xe641;</i>
          </div>
          <div @click="editPwd" class="mt-20">
            <i class="iconfont">&#xe620;</i>
            <span class="f18">修改密码</span>
            <i class="iconfont fr" style="color:#c7c7cc;font-size:22px;">&#xe641;</i>
          </div>
        </div>
        <div class="bgc-white padding-20 mt-20">
          <div @click="editPhone">
            <i class="iconfont">&#xe639;</i>
            <span class="f18">更改手机号</span>
            <i class="iconfont fr" style="color:#c7c7cc;font-size:22px;">&#xe641;</i>
          </div>
          <div @click="editEmail" class="mt-20">
            <i class="iconfont">&#xe610;</i>
            <span class="f18">更改邮箱</span>
            <i class="iconfont fr" style="color:#c7c7cc;font-size:22px;">&#xe641;</i>
          </div>
          <div @click="loginout" class="mt-20">
            <i class="iconfont">&#xe70b;</i>
            <span class="f18">退出登录</span>
            <i class="iconfont fr" style="color:#c7c7cc;font-size:22px;">&#xe641;</i>
          </div>
        </div>
      </div>
    </template>
    <!-- 未登录 -->
    <template v-else>
      <div class="tac nologin" style="font-size:18px;">
        <router-link to="/login"> <el-button type="primary" plain>未登录，请点击登录</el-button></router-link>
      </div>
    </template>
  </div>
</template>

<script>
export default {
  data: function () {
    return {
      isShow: false
    }
  },
  methods: {
    editPersonInfo: function () {
      this.$router.push('/editpersoninfo')
    },
    editPwd: function () {
      this.$router.push('/editpwd')
    },
    editEmail: function () {
      this.$router.push('/editemail')
    },
    editPhone: function () {
      this.$router.push('/editphone')
    },
    goCollect: function () {
      this.$router.push('/mobcoll')
    },
    loginout: function () {
      this.$layer.dialog({
        title: ['', 'background:#fff;'],
        content: '是否退出登录?',
        contentClass: 'className',
        btn: ['取消', '确定']
      }).then(async res => {
        // res为0点击了左边，1点击了右边
        let positon = res != 0
        if (res) {
          window.localStorage.removeItem('token')
          this.$router.push('/login')
          this.$layer.toast({
            icon: 'icon-check',
            content: '已退出登录',
            time: '1000'
          })
        }
      })
    }
  },
  mounted: function () {
    var token = window.localStorage.getItem('token')
    if (token) {
      this.isShow = true
    } else {
      this.isShow = false
    }
    document.querySelector('#app').scrollIntoView(true)
  }
}
</script>

<style scoped lang="scss">
.mob-per-top {
  height: 80px;
  line-height: 100px;
  font-size: 18px;
  font-weight: bold;
  background-color: #fff;
  width: 100%;
}
.mob-collet {
  //   height: 60px;
  //   line-height: 60px;
  background-color: #fff;
  padding: 20px 20px;
  margin-top: 20px;
}
.nologin {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
</style>



// WEBPACK FOOTER //
// src/components/mobile/personinfo.vue